import { useNavigate } from "react-router-dom";

export default function PartnerCard({ partner }) {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate("/partners/info?id=" + partner.id)}
      className="grid text-sm pill md:grid-cols-3 justify-items-center text-stone-200"
    >
      <p className="">{partner.name}</p>
      <p className="">{partner.email}</p>
      <p className="">{partner.phone}</p>
    </div>
  );
}
